import React, { useState } from "react";
import styles from "./addproduct.module.scss";
import Proptypes from "prop-types";
import StepTwoProgress from "../../../../assets/images/brand-steps-progress-indicator/step-two.svg";
import Textfield from "../../../Shared/Textfield";
import Button from "../../../Shared/Button";
import TooltipIcon from "../../../../assets/images/tooltip-icon.svg";

const StepTwo = ({ handleChange, toggle, setStep, step, formData, isEdit }) => {
  const [errors, setErrors] = useState({
    Certifications: "",
    country: "",
    productURL: "",
  });
  return (
    <>
      <div className={styles["progress_container"]}>
        <div className={styles["progress_container_indicator"]}>
          <img src={StepTwoProgress} width={232} height={42} alt="progress" />
        </div>
      </div>
      <div
        className={`${styles["header_container"]} ${styles["header_steptwothree"]}`}
      >
        <p className={styles["header_heading"]}>
          {isEdit ? "Edit" : "Add"} product
        </p>
      </div>
      <div className={styles["label_container"]}>
        Let’s get a little bit of info on the product (* indicates that it can
        not be changed later)
      </div>

      <div className={styles["steptwothree_fields_container"]}>
        <Textfield
          type="text"
          placeholder="Certifications"
          name="Certifications"
          id="Certifications"
          onChange={handleChange}
          className={styles["input_field_container"]}
          error={errors?.Certifications}
          value={formData?.values?.Certifications}
          touched={errors?.Certifications}
        />
        <Textfield
          type="text"
          placeholder="Country of Origin"
          className={`${styles["input_field_container"]}`}
          name="country"
          id="Country"
          onChange={handleChange}
          error={errors?.country}
          touched={errors?.country}
          value={formData?.values?.country}
        />
        <div
          className={`${styles["orderlink_field"]} ${styles["tooltip_input_container"]}`}
        >
          <Textfield
            type="text"
            placeholder="Order Link"
            className={`${styles["input_field_container"]}`}
            name="productURL"
            id="productURL"
            error={errors?.productURL}
            value={formData?.values?.productURL}
            touched={errors?.productURL}
            onChange={handleChange}
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              paddingRight: "60px",
            }}
          />
          <div className={styles["tooltipiconField"]}>
            <img src={TooltipIcon} alt="tooltipicon" width={24} height={24} />
            <div className={styles["tooltip_container"]}>
              <div className={styles["heading"]}>Order Link</div>
              <div className={styles["divider"]} />
              <div className={styles["text"]}>
                Link to this product in your online store. When a user taps
                "Order," they follow this link.
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={styles["buttons_container"]}>
        <div>
          <Button
            className={`${styles["button_cancel"]} ${styles["steptwothree_buttons_layout"]}`}
            onClick={toggle}
            text={"Cancel"}
          />
        </div>
        <div>
          <Button
            className={`${styles["button_active"]} ${styles["steptwothree_buttons_layout"]}`}
            onClick={() => {
              const fields = ["Certifications", "country", "productURL"];
              const errorsObj = fields.reduce((acc, field) => {
                if (!formData?.values[field]) {
                  acc[field] = "Required";
                }
                return acc;
              }, {});

              setErrors(errorsObj);

              if (fields.every((field) => formData?.values[field])) {
                setStep(step + 1);
              }
            }}
            text={"Next"}
          />
        </div>
      </div>
    </>
  );
};

StepTwo.propTypes = {
  handleChange: Proptypes.func,
  toggle: Proptypes.func,
  setStep: Proptypes.func,
  step: Proptypes.number,
  formData: Proptypes.object,
  isEdit: Proptypes.bool,
};
export default StepTwo;
